<template>
  <section>
    <!-- Different views of the event detail page, e.g. 'Classic', 'Selling', or 'Story' -->
    <component :is="viewCompoment" />
  </section>
</template>

<script>
function loadView(viewName) {
  return () =>
    import(
      /* webpackChunkName: "[request]" */
      `@/components/event/eventDetails/ViewTypes/${viewName}.vue`
    );
}

export default {
  name: 'Homepage',
  components: {
    EventDetailsClassicView: loadView('EventDetailsClassicView'),
    EventDetailsSellingAndStoryView: loadView(
      'EventDetailsSellingAndStoryView'
    ),
  },
  computed: {
    partnerGroupId() {
      return this.$store.getters['Account/partnerGroupDetails'].PartnerGroupId;
    },
    breakpointSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    viewType() {
      // 'Classic' | 'Selling' | 'Story' | 'Professional' | 'ProfessionalBeta' | 'Luxury'
      return this.$store.getters['Account/partnerGroupDetails'].ViewType;
    },
    viewCompoment() {
      switch (this.viewType) {
        case 'Classic':
          return 'EventDetailsClassicView';
        default:
          return 'EventDetailsSellingAndStoryView';
      }
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
